import { FC, Fragment } from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSearchableEntities from '../../../components/forms/CustomSearchableEntities';
import useCorporations from '../../../hooks/api-calls/useCorporations';
import { FilterOptions } from '../../../hooks/useFilters';


interface IRemittancesFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const RemittancesFilters: FC<IRemittancesFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    // HOOKS

    const { fetchCorporations } = useCorporations();

    // RENDER

    return (
        <Fragment>
            <CustomSearchableEntities
                id="corporations"
                label="Empresa Fiscal"
                filters={filters}
                updateFilters={updateFilters}
                fetchOptions={async (searchText: string | null) => {
                    return fetchCorporations({ search_text: searchText, ids: filters.filter_filters?.client ?? [] });
                }}
                permissions={[
                    {
                        group: 'corporation',
                        action: 'get_corporations_for_select',
                    }
                ]}
            />

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </Fragment>
    )
}

export default RemittancesFilters;